/* eslint-disable @atlaskit/design-system/use-primitives-text */
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import { LogoSvg } from '@atlassian/generative-ai-modal/assets/Logo';
import { messages } from './messages';
import { aiFloatingToolbarCss } from './styles';
export var AIFloatingToolbarFooter = function AIFloatingToolbarFooter() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return jsx("div", null, jsx("div", {
    css: aiFloatingToolbarCss
  }, jsx("p", null, formatMessage(messages.contentQuality)), jsx(Lozenge, null, "BETA")), jsx("div", {
    css: aiFloatingToolbarCss
  }, jsx("p", null, formatMessage(messages.poweredByAi)), jsx(LogoSvg, {
    alt: formatMessage(messages.logoAltText),
    size: 14,
    colorStart: "var(--ds-text-subtlest, #626F86)",
    colorStop: "var(--ds-text-subtlest, #626F86)"
  })));
};